// 设置 rem 函数
function setRem () {
	var docEl = document.documentElement;
	var clientWidth = docEl.clientWidth;
	console.log(clientWidth);
	//设定最大不超过6p的宽度
	if(clientWidth>=414){
		clientWidth=414;
	}
	if (!clientWidth) return;
	var size = clientWidth / 7.2;
	if (size > 100) size = 100; 
	var domel = document.documentElement;
	if(window.parent){
		domel = window.parent.document.documentElement;
	}
	if(navigator.userAgent.match(/MicroMessenger/i)!==null && (domel.clientHeight / domel.clientWidth)<=1.75){
		size = size*0.9;
	}else if((domel.clientHeight / domel.clientWidth)<=1.75){
		size = size*0.9
	}
	docEl.style.fontSize = size + 'px';
	window.baseRem = size;
	console.log(clientWidth);
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
 setRem()
}